export default "/images/vendor/flag-icon-css/flags/1x1/ss.svg?2ad5a2bbc138690704ada7e1a8577410";